import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, tap, catchError } from 'rxjs';
import { RetailerProfileInterface } from '../profiles/dashboard/dashboard.interface';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { LoaderService } from '../services/loader/loader.service';

@Injectable({ providedIn: 'root' })
export class PublicDashboardResolver implements Resolve<Observable<RetailerProfileInterface | null>> {
  constructor(
    private dashboardService: DashboardService,
    private loader: LoaderService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RetailerProfileInterface | null> {
    this.loader.setIsLoading(true);

    const slug = route.queryParamMap.get('slug');
    const id = route.queryParamMap.get('id');
    const compareRCL = route.queryParamMap.get('compare');

    return this.dashboardService.loadPublicDashboardData(slug, id, compareRCL).pipe(
      tap(() => this.loader.setIsLoading(false)),
      catchError((error: any) => {
        console.error('Error loading public dashboard data', error);
        return of(null);
      })
    );
  }
}
